import React, { useState } from 'react';
import { useGame } from '../context/GameContext';
import { Activity, ChevronDown, ChevronUp } from 'lucide-react';

// v2.3 QoL — Compact floating "run stats" pill top-left. Collapsible.
// Hidden on menu, only shown when a run is active.

export default function RunStatsHUD() {
  const { run, screen } = useGame();
  const [open, setOpen] = useState(false);
  if (!run) return null;
  if (['menu','avatar','codex','profile','party'].includes(screen)) return null;
  const s = run._runStats || {};
  const stats = [
    { key: 'floor', label: 'FLOOR', v: (run.floorIdx || 0) + 1 },
    { key: 'floors', label: 'CLEARED', v: s.floorsCleared || 0 },
    { key: 'kills', label: 'KILLS', v: s.kills || 0 },
    { key: 'dmg', label: 'DMG DEALT', v: s.dmgDealt || 0 },
    { key: 'taken', label: 'DMG TAKEN', v: s.dmgTaken || 0 },
    { key: 'big', label: 'BIGGEST HIT', v: s.biggestHit || 0 },
    { key: 'cards', label: 'CARDS PLAYED', v: s.cardsPlayed || 0 },
    { key: 'turns', label: 'TURNS', v: s.turnsUsed || 0 },
    { key: 'syn', label: 'SYNERGIES', v: s.synergiesFired || 0 },
  ];
  return (
    <div
      className="fixed bottom-2 left-2 z-30 brutal-border bg-[#0a0a0a]/95 p-2 pr-3 text-xs font-mono"
      style={{ borderColor: 'var(--text-dim)', boxShadow: '3px 3px 0 var(--text-dim)' }}
      data-testid="run-stats-hud"
    >
      <button
        className="flex items-center gap-1.5 text-[10px] uppercase tracking-widest text-[color:var(--neon)]"
        onClick={() => setOpen(o => !o)}
        data-testid="run-stats-toggle"
      >
        <Activity size={12}/> RUN STATS
        {open ? <ChevronDown size={12}/> : <ChevronUp size={12}/>}
      </button>
      {open && (
        <div className="mt-2 grid grid-cols-2 gap-x-4 gap-y-1" data-testid="run-stats-body">
          {stats.map(st => (
            <div key={st.key} className="flex justify-between gap-2" data-testid={`run-stat-${st.key}`}>
              <span className="text-[color:var(--text-dim)]">{st.label}</span>
              <span className="text-[color:var(--neon)] font-bold">{st.v}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
